export default __webpack_public_path__ + "static/media/warning.0f4e2c2a.svg";